var map = {
	"./spot125.jpg": 8015,
	"./spot150.jpg": 7679,
	"./spot150.png": 4431,
	"./spot165.jpg": 2843,
	"./spot190.jpg": 6227,
	"./spot240.jpg": 9879,
	"./spot240.png": 295,
	"./spot70.jpg": 4096,
	"./spot90.jpg": 3214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3785;